import React from 'react';
import { Box, Typography } from '@mui/material';
import { looksLikeHtml, stripHtmlTags } from '../../utils/htmlText';

/**
 * HTML varsa render eder; düz metinse olduğu gibi gösterir.
 * rawHtml=false ile sadece düz metin (etiketsiz) basar.
 */
const HtmlContent = ({ html, empty = '—', plainText = false, sx = {} }) => {
  if (html == null || html === '') {
    return (
      <Typography component="span" sx={{ color: 'text.secondary', ...sx }}>
        {empty}
      </Typography>
    );
  }

  const str = String(html);
  if (plainText || !looksLikeHtml(str)) {
    const text = looksLikeHtml(str) ? stripHtmlTags(str) : str;
    return (
      <Typography
        component="div"
        sx={{
          fontSize: 14,
          fontWeight: 500,
          color: '#0F2137',
          lineHeight: 1.55,
          whiteSpace: 'pre-wrap',
          wordBreak: 'break-word',
          ...sx,
        }}
      >
        {text || empty}
      </Typography>
    );
  }

  return (
    <Box
      className="html-content"
      sx={{
        fontSize: 14,
        fontWeight: 500,
        color: '#0F2137',
        lineHeight: 1.55,
        wordBreak: 'break-word',
        '& p': { m: 0, mb: 1, '&:last-child': { mb: 0 } },
        '& ul, & ol': { m: 0, pl: 2.5, mb: 1 },
        '& a': { color: 'primary.main' },
        ...sx,
      }}
      dangerouslySetInnerHTML={{ __html: str }}
    />
  );
};

export default HtmlContent;
